export default "__VITE_ASSET__DmyJ9cZa__"